export default __webpack_public_path__ + "static/media/linkedin.a4464e90.svg";